import axios from 'axios';
import store from '../store'
import { Auth } from 'aws-amplify';

class CognitoAuthRepository {

    constructor() {
        this.basePath = store.state.backend;
    }

    getLastCode(email,securityCode) {
        return axios.get(`${this.basePath}/cognito-auth/${email}/get-last-code-and-reset/${securityCode}`)
    }

    
    isUsernameInCognitoPool(username) {
        return axios.get(`${this.basePath}/cognito-auth/is-username-in-pool/${username}`);
    }

    postCognitoAuthFromSwisetUser(userEmail,swisetEmail,embedKey){
        const query = embedKey ? `?embedKey=${encodeURIComponent(embedKey)}` : ''
        return axios.post(`${this.basePath}/cognito-auth/from-swiset-user/${userEmail}/${swisetEmail}${query}`)
    }

    /**
     *
     * @param {string} userEmail It is the email to be/or registered in the user pool in cognito
     * @param {string} swisetEmail It is the email used to associate a swiset main account to the cognito identity with the userEmail
     * @param {string} [embedKey] The whitelabel api key the embed was loaded with. The backend requires it whenever the
     *                 two emails differ, which only happens inside a partner's embed: that check used to live in the
     *                 browser alone, where a script calling the endpoint directly simply skipped it.
     * @returns
     */
    async createCognitoAuthFromSwisetUser(userEmail,swisetEmail,embedKey) {
        const randomString = (n) => [...Array(n)].map(() => {
            const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            return charSet.charAt(Math.floor(Math.random() * charSet.length));
          }).join('');
        const params = {
          username: userEmail,
          password: randomString(30)+'!Ab4',
          attributes: {
            email: userEmail
          },
        }
        let canContinue = await Auth.signUp(params).then((cognitoResponse) => {
            return cognitoResponse.userConfirmed
        }).catch((error) => {
            if (process.env.NODE_ENV !== 'production') {
                // eslint-disable-next-line no-console
                console.error('Cognito signUp:', error && error.message ? error.message : error)
            }
            return error.message.includes('User already exists')
        })
        if(canContinue){
            const response = await this.postCognitoAuthFromSwisetUser(userEmail,swisetEmail,embedKey)
            return response.status<400
        }else{
            return false
        }
    }

    confirmMagicLink(email,cognitoCode,securityCode){
        return axios.get(`${this.basePath}/cognito-auth/${email}/set-last-code/${cognitoCode}/${securityCode}`)   
    }
}

export default new CognitoAuthRepository();
